export default "__VITE_ASSET__Duh$oizW__"